export const isPrefixSignPresent = (mobileNo) => {
  return !!(mobileNo && mobileNo.includes('+'));
};
